'use client';

import { Skeleton } from '@ui/components/skeleton';
import { cn } from '@ui/lib';
import dynamic from 'next/dynamic';

interface GistProps {
	gistId: string;
	file?: string;
	className?: string;
	title?: string;
}

const GistImport = dynamic(() => import('react-gist'), {
  ssr: false,
  loading: () => <Skeleton className="h-[32px] w-full" />,
});

export function Gist({ gistId, file, className, title }: GistProps) {
  return (
		<div className={cn("not-prose my-8", className)}>
			{title && (
				<div className="mb-2 text-sm font-medium">
					{title}
				</div>
			)}
			<div className="relative overflow-hidden rounded-lg border bg-card shadow-sm min-h-[640px]">
				<GistImport id={gistId} file={file} />
			</div>
		</div>
	);
}
